import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { t } from "../../i18n";

// Ctrl+G: organizar a camada (ou o grupo) selecionado em um grupo existente ou novo.
export function GroupDialog({ open, onOpenChange, target, groups, colors, onApply, onRemove }) {
  const [choice, setChoice] = useState("");
  const [novo, setNovo] = useState("");
  useEffect(() => {
    if (!open) return;
    const current = target?.kind === "group" ? target.name : (target?.el?.grupo || "");
    setChoice(current || (groups[0] || "__new__"));
    setNovo("");
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!target) return null;
  const isGroup = target.kind === "group";
  const currentGroup = isGroup ? target.name : target.el?.grupo;
  const finalName = choice === "__new__" ? novo.trim() : choice;
  const apply = () => { if (finalName) { onApply(finalName); onOpenChange(false); } };
  const inp = "w-full h-9 bg-input border border-border rounded-sm px-2 text-sm outline-none focus:border-primary";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="group-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{isGroup ? t("Organizar grupo") : t("Agrupar camada")}</DialogTitle>
          <DialogDescription>
            {isGroup ? t("Mover todas as camadas de \"{nome}\" para outro grupo.", { nome: target.name }) : t("Escolha o grupo de \"{nome}\".", { nome: target.el?.nome || "" })}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-[11px] text-muted-foreground" htmlFor="group-dialog-select">{t("Grupo")}</label>
          <div className="flex flex-wrap gap-1.5" id="group-dialog-select" role="radiogroup">
            {groups.map((g) => (
              <button key={g} role="radio" aria-checked={choice === g} onClick={() => setChoice(g)}
                className={`flex items-center gap-1.5 px-2.5 h-8 rounded-sm border text-xs ${choice === g ? "border-primary bg-primary/15" : "border-border hover:border-primary/40"}`}
                data-testid={`group-dialog-opt-${g}`}>
                <span className="h-2 w-2 rounded-full" style={{ background: colors[g] }} />{g}{g === currentGroup && <span className="text-muted-foreground">· {t("atual")}</span>}
              </button>
            ))}
            <button role="radio" aria-checked={choice === "__new__"} onClick={() => setChoice("__new__")}
              className={`px-2.5 h-8 rounded-sm border border-dashed text-xs ${choice === "__new__" ? "border-primary bg-primary/15" : "border-border hover:border-primary/40"}`}
              data-testid="group-dialog-new">{t("＋ Novo grupo")}</button>
          </div>
          {choice === "__new__" && (
            <input id="group-dialog-name" autoFocus className={inp} placeholder={t("Nome do grupo")} value={novo}
              onChange={(e) => setNovo(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") apply(); }} data-testid="group-dialog-name" />
          )}
        </div>
        <DialogFooter className="gap-2 sm:justify-between">
          {currentGroup ? (
            <Button variant="ghost" size="sm" onClick={() => { onRemove(); onOpenChange(false); }} data-testid="group-dialog-remove">
              {isGroup ? t("Desagrupar") : t("Remover do grupo")}
            </Button>
          ) : <span />}
          <Button size="sm" onClick={apply} disabled={!finalName || finalName === currentGroup} data-testid="group-dialog-apply">{t("Aplicar")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
